import { Component, DestroyRef, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { InfoboxComponent } from '@core/components-infobox-legacy';
import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import { JobsWrapperActionsService } from '@core/offers-data';
import { ButtonComponent, DialogService } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-switch-editors-infobox',
  imports: [InfoboxComponent, TranslatePipe, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './switch-editors-infobox.component.html',
})
export class SwitchEditorsInfoboxComponent {
  private readonly jobsWrapperActionsService = inject(JobsWrapperActionsService);
  private readonly dialogService = inject(DialogService);
  private readonly i18n = inject(I18nService);
  private readonly destroyRef = inject(DestroyRef);
  protected count = input(1);
  protected jobsToUpdateCount = input(0);

  public onSwitchEditorsClick(): void {
    this.dialogService
      .information({
        title: this.i18n.translate('app.offers.switch_to_prosemirror_confirm_dialog.title', {
          count: this.count(),
        }),
        message: this.i18n.translate('app.offers.switch_to_prosemirror_confirm_dialog.message', {
          count: this.count(),
        }),
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result) {
          this.jobsWrapperActionsService.switchJobsToProsemirror();
        }
      });
  }
}
